import React, { useState } from 'react';
import { FlatList } from 'react-native';
import type { FundProps } from "../../types";
import { Button, Text, TextInput, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type FundActionsProps = {
    fund:FundProps,
    onWorkCapital:(amount:number) => void,
    onLayoffCapital:(amount: number) => void,
    onDepositFund:(amount: number) => void,
    onReleaseFunds:(amount:number) => void
}

const FundActions = ({ fund, onWorkCapital, onLayoffCapital, onDepositFund }:FundActionsProps) => {
    const Colors = useColors();
    const [ show_actions, setShowActions ] = useState(false);
    const [ selected_action, setSelectedAction ] = useState<any | undefined>(undefined);
    const [ amount, setAmount ] = useState('');

    const actions = [
        {action:'deposit', label:'Deposit Capital', color:Colors.text.success},
        {action:'work', label:'Work Capital', color:Colors.text.action},
        {action:'layoff', label:'Layoff Capital', color:Colors.text.error}
    ]

    const renderActions = (data:{item:any, index:number}) => {
        return (
            <Button style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }} onPress={() => setSelectedAction(data.item)}>
                <View transparent style={{ flex:1 }}>
                    <Text size={14} color={data.item.color} weight='semibold'>{data.item.label}</Text>
                </View>
            </Button>
        )
    }

    let action_valid = selected_action && !isNaN(parseFloat(amount)) ? true : false

    const handleAction = (selected_action:{ action:string }) => {
        setSelectedAction(undefined);
        setShowActions(false);
        switch(selected_action.action){
            case 'deposit':
                return onDepositFund(parseFloat(amount))
            case 'work':
                return onWorkCapital(parseFloat(amount))
            case 'layoff':
                return onLayoffCapital(parseFloat(amount))
            default: return alert('Not handled')
        }
    }

    return (
        <View type='header' style={{ flexDirection:'row', alignItems:'center', zIndex:1 }}>
            <View transparent style={{ flex:1 }}>
                <Text theme='h1'>{fund.name}</Text>
                <Text style={{ marginTop:3 }} theme='description'>${fund.invested_capital.toFixed(2)} Total Invested</Text>
            </View>
            <View transparent style={{ padding:10, borderRightWidth:1, borderColor:Colors.borders.light }}>
                <Text textAlign='center' size={14} color={Colors.text.success}>${fund.available_capital.toFixed(2)}</Text>
                <Text textAlign='center' size={14} color={Colors.text.success}>Available</Text>
            </View>
            <View transparent style={{ padding:10, borderRightWidth:1, borderColor:Colors.borders.light }}>
                <Text textAlign='center' size={14} color={Colors.text.action}>${fund.working_capital.toFixed(2)}</Text>
                <Text textAlign='center' size={14} color={Colors.text.action}>Working</Text>
            </View>
            <View transparent style={{ padding:10 }}>
                <Text textAlign='center' size={14} color={Colors.text.action}>${fund.deployed_capital.toFixed(2)}</Text>
                <Text textAlign='center' size={14} color={Colors.text.action}>Deployed</Text>
            </View>
            <Button
                title='ACTIONS'
                style={{ marginLeft:10 }}
                onPress={() => setShowActions(true)}
                type='action'
            />
            {show_actions ?
            <View style={{ position:'absolute', top:0, right:0 }}>
                <View style={{minWidth:275 }}>
                    <View type='header' style={{ flexDirection:'row', alignItems:'center' }}>
                        <View transparent style={{ flex:1 }}>
                            <Text theme='h2'>Fund Actions</Text>
                        </View>
                        <Button
                            title='X'
                            type='close'
                            onPress={() => setShowActions(false)}
                        />
                    </View>
                    {!selected_action ?
                    <View style={{  padding:0 }}>
                        <FlatList
                            data={actions}
                            key={'action_list'}
                            keyExtractor={(item) => item.action}
                            renderItem={renderActions}
                        />
                    </View>
                    :
                    <View>
                        <View style={{ padding:0 }}>
                            <View style={{ padding:10 }}>
                                <Text size={14} theme='description' textAlign='center'>{selected_action.label}</Text>
                            </View>
                            <View type='input'>
                                <Text size={14} theme='h1'>$</Text>
                                <TextInput
                                    style={{ marginLeft:3, flex:1 }}
                                    placeholder='0'
                                    value={amount}
                                    onChangeText={(text) => setAmount(text)}
                                />
                            </View>
                        </View>
                        <View type='footer' style={{ flexDirection:'row', alignItems:'center' , padding:5}}>
                            <Button
                                title='CANCEL'
                                style={{ flex:1, minWidth:80, marginRight:5 }}
                                type='error'
                                onPress={() => setSelectedAction(undefined)}
                            />
                            <Button
                                title='SUBMIT'
                                style={{ flex:2, opacity: action_valid ? 1 : 0.5 }}
                                disabled={!action_valid}
                                type='success'
                                onPress={() => handleAction(selected_action)}
                            />
                        </View>
                    </View>
                    
                    }
                </View>
            </View>
            :<></>}
        </View>
    )

}

export default FundActions